import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { useAppContext } from '@/app/_tech';
import { computed } from 'vue';
import { Sunrise } from '@/logic/_infra/time'
import * as sys from '@/sys'
import { WorkspaceRmodel } from '@/app.context/workspace.rmodel';
import dayjs from 'dayjs';
import {personEndeavoursStrings} from '@/controllers/workspaces/person.controller'



export default /*#__PURE__*/_defineComponent({
  __name: 'UserEdeavoursControl',
  props: {
    items: {}
  },
  setup(__props: any) {

//import { userEndeavourStrings } from '@/app/workspace/_controllers'
const props = __props

// const context = useAppContext();

// const user_endeavours = computed(() => userEndeavourStrings(context.cursor.workspace))

// function userEndeavourStrings(w: WorkspaceRmodel | null) {

//     //const buffer: string[] = [];

//     if (w == null || w.user_person == null) return [];

//     return personEndeavoursStrings(w.user_person)
// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (n, i) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "lib-bulleted",
        key: i
      }, _toDisplayString(n), 1))
    }), 128))
  ]))
}
}

})